// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__3ffrH","buttons":"PendingPaymentAlert_buttons__2ne7i"};